import React from 'react';

interface MoodboardTitleProps {
  title: string;
}

export default function MoodboardTitle({ title }: MoodboardTitleProps) {
  return (
    <div className="mb-[30px] flex justify-center gap-[24px] items-start">
      <h2 className="font-nhg font-normal uppercase text-[100px] xl:text-[123px] inline-block break-works text-center leading-[100%]">
        {title}
      </h2>
    </div>
  );
}
